import { apiInstance } from '../client';

export type PostRentalProjectionFields = {
  full_name: string;
  email: string;
  phone: string;
  address: string;
  furnished_state?: 'yes' | 'no' | 'partially';
  is_previously_listed?: boolean;
  external_channel_url?: string;
  additional_external_channel_url?: string;
  other_notes?: string;
  photos?: string[];
};

export async function postRentalProjection(
  fields: PostRentalProjectionFields
): Promise<void> {
  await apiInstance.post(
    '/v2/newsletter/send_request_rental_projection',
    fields
  );
}
